import { getApv, postApv, postBrandAprv } from '../../apis';
import { SDK_DOMAIN } from '../../constants';
import {
  deserialize,
  getIframe,
  getLocationPath,
  setAddEventListener,
  setIframeInnerHtml,
} from '../../helpers';
import { replaceRouter, routes } from '../../router';
import { amtFormatter } from '../../utils/common';

const RemitcComplete = {
  render: async () => {
    return '';
    // const state = history.state;

    // let html = '';
    // if (state.refererHash != routes.chargRemitcUid.hashPath) {
    //   html += `
    //     <div class="c_box c_bod3 m_t_10">
    //         <span class="c_label1">입금계좌</span>
    //         <span class="c_label5_1">${state.bankNm} ${state.accno}</span>
    //     </div>
    //     <div class="c_box c_bod3 m_t_10">
    //         <span class="c_label1">보낸금액</span>
    //         <span class="c_label5_1">${amtFormatter(state.outAmt)}</span>
    //     </div>
    //   `;
    // } else {
    //   html += `
    //     <div class="c_box c_bod3 m_t_10">
    //         <span class="c_label1">받는사람 (UID)</span>
    //         <span class="c_label5_1">${state.uid}</span>
    //     </div>
    //     <div class="c_box c_bod3 m_t_10">
    //         <span class="c_label1">보낸금액</span>
    //         <span class="c_label5_1">${amtFormatter(state.outAmt)}</span>
    //     </div>
    //   `;
    // }

    // if (state.refererHash != routes.accountRemitc.hashPath) {
    //   html += `
    //     <div class="c_box c_bod3 m_t_10">
    //         <span class="c_label1">충전머니 잔액</span>
    //         <span class="c_label5_1" id="chrg_bal"></span>
    //     </div>
    //   `;
    // }

    // return `
    //   <div>
    //       <a id="connect_pay_back_button" class="c_back"></a>
    //   </div>
    //   <div class="c_title1">${
    //     state.refererHash == routes.accountRemitc.hashPath ? '계좌' : '충전머니'
    //   } 송금</div>
    //   <div id="contents" style="display:none">
    //     <div class="c_result_icon m_b_20"><img src="${SDK_DOMAIN}/images/icon-success.png" /></div>
    //     <div class="c_label4_4 m_b_20 text_center">송금이 완료되었습니다.</div>

    //     <div class="bottom_btn_wrapper">
    //       ${html}
    //       <button id="ok_btn" class="btn c_btn1 skin1_btn m_t_25">확인</button>
    //     </div>
    //   </div>
    // `;
  },
  afterRender: async () => {
    const state = history.state;
    const data = deserialize(sessionStorage.getItem('CONPAY_COMPLETE_INFO'));
    if (data == null) {
      replaceRouter(
        { message: '올바르지 않은 접근입니다' },
        null,
        routes.resultPage.hashPath
      );
      return;
    }

    try {
      // 이체 예약
      // const res = await postApv(state.rsvdUrl, data);

      // 브랜드사 백엔드에서 승인 API 데이터
      // const aprvData = {
      // rsvdno: res.rsvdno,
      // ...data,
      // };
      window.brandResolve(data);
      // await postBrandAprv(state.aprvUrl, aprvData);

      // if (state.refererHash != routes.accountRemitc.hashPath) {
      //   // 충전머니 잔액조회
      //   const balRes = await getApv('charging/moneyBalance');
      //   setIframeInnerHtml('chrg_bal', amtFormatter(balRes.chrgBal));
      // }

      // getIframe().getElementById('contents').style.display = 'block';
    } catch (e) {
      window.brandReject(e);
      // replaceRouter(
      //   { title: '송금 실패', message: e.resultMessage },
      //   null,
      //   routes.resultPage.hashPath
      // );
      console.error(e);
    } finally {
      sessionStorage.removeItem('CONPAY_COMPLETE_INFO');
      const locationPath = getLocationPath();
      window.parent.location.replace(`${locationPath}#close`);
    }

    // setAddEventListener('ok_btn', () => {
    //   history.go(-2);
    // });
    // setAddEventListener('connect_pay_back_button', () => {
    //   history.go(-2);
    // });
  },
};
export default RemitcComplete;
